import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  backgroundColor: theme.palette.background.secondary,
  padding: "60px 20px",
}));

export const ContentBox = styled(Box)(() => ({
  maxWidth: "900px",
  margin: "0 auto",
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: "32px",
  fontWeight: 700,
  color: theme.palette.primary.main,
  marginBottom: "32px",
  fontFamily: "Nunito",
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  fontWeight: 700,
  color: theme.palette.primary.main,
  marginTop: "40px",
  marginBottom: "16px",
  fontFamily: "Nunito",
}));

export const Paragraph = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  color: theme.palette.text.primary,
  lineHeight: "1.6",
  marginBottom: "16px",
  fontFamily: "Nunito",
  textAlign: "justify",
}));

export const BulletList = styled("ul")(() => ({
  margin: "0 0 16px 0",
  paddingLeft: "24px",
}));

export const BulletItem = styled("li")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  color: theme.palette.text.primary,
  lineHeight: "1.6",
  fontFamily: "Nunito",
  marginBottom: "6px",
}));

export const ConsentBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
  padding: "20px 24px",
  marginTop: "8px",
  marginBottom: "16px",
}));

export const ConsentText = styled(Typography)(({ theme }) => ({
  fontSize: "15px",
  fontWeight: 400,
  color: theme.palette.text.primary,
  lineHeight: "1.7",
  fontFamily: "Nunito",
  fontStyle: "italic",
}));

export const ScreenshotRow = styled(Box)(() => ({
  display: "flex",
  gap: "24px",
  marginTop: "24px",
  marginBottom: "24px",
  flexWrap: "wrap",
}));

export const ScreenshotImage = styled("img")(() => ({
  width: "100%",
  borderRadius: "12px",
  boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
  display: "block",
}));

export const InlineLink = styled("a")(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: "none",
  fontWeight: 600,
  "&:hover": {
    textDecoration: "underline",
  },
}));

export const Divider = styled(Box)(({ theme }) => ({
  height: "1px",
  backgroundColor: theme.palette.divider,
  marginTop: "40px",
  marginBottom: "16px",
}));

export const Note = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 400,
  color: theme.palette.text.secondary,
  lineHeight: "1.6",
  fontFamily: "Nunito",
  fontStyle: "italic",
  marginTop: "24px",
}));

